/**
 * アセット読み込みクラス
 */

export default class AssetsLoader{

    constructor(scene){
        this.scene = scene;
    }


    /**
     * アセットの読み込み
     * @param assets
     */
    load(assets){
        let i;

        // 画像読み込み
        if(assets.image){

            for(i=0; i<assets.image.length; i++){
                const image = assets.image[i];
                this.scene.load.image(image.name, image.file);
            }
        }
        
        // スプライトシート読み込み
        if(assets.spritesheet){

            for(i=0; i<assets.spritesheet.length; i++){
                const sprite = assets.spritesheet[i];
                this.scene.load.spritesheet(sprite.name, sprite.file, {frameWidth:sprite.w, frameHeight:sprite.h});
            }
        }
    }


    /**
     * preload後のアセット読み込み
     */
    afterLoad(assets, callback){
        this.scene.load.once('complete', callback, this);
        this.load(assets);
        this.scene.load.start();
    }
}